import { render, staticRenderFns } from "./WorkspaceDimensions.vue?vue&type=template&id=f6c646c4&"
import script from "./WorkspaceDimensions.vue?vue&type=script&lang=js&"
export * from "./WorkspaceDimensions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports